import EventsListing from './EventsListing';

export default EventsListing;
